export default "__VITE_ASSET__e90af77a__"